import _ from 'lodash'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { getSubStationId } from '../../../../lib/ReduxFormSelectors/ProposalListingForm'

const getSubStationCategories = state => _.get(state, 'proposal.subStationCategories', [])

export const currentSubStationSelector = createSelector([getSubStationId, getSubStationCategories], (subStationId, subStations) => {
  return _.find(subStations, { categoryId: subStationId }) || {}
})

export default function withCurrentSubStation (MainComponent) {
  return connect(
    state => {
      return ({
        currentSubStation: currentSubStationSelector(state)
      })
    })(MainComponent)
}
